import { useCallback, useRef, useState } from 'react';

// Sound effects URLs (using free sound effects)
const SOUNDS = {
  shuffle: null, // Disabled
  cardFlip: 'https://assets.mixkit.co/active_storage/sfx/2571/2571-preview.mp3',
  reveal: 'https://assets.mixkit.co/active_storage/sfx/1435/1435-preview.mp3',
  ambient: 'https://assets.mixkit.co/active_storage/sfx/2515/2515-preview.mp3'
};

export const useSound = () => {
  const [isMuted, setIsMuted] = useState(false);
  const audioRefs = useRef({});

  const playSound = useCallback((soundKey, volume = 0.5) => {
    if (isMuted) return;
    
    const soundUrl = SOUNDS[soundKey];
    if (!soundUrl) return; // Skip if sound is disabled/null
    
    try {
      const audio = new Audio(soundUrl);
      audio.volume = volume;
      audio.play().catch(() => {
        // Autoplay blocked by browser — safe to ignore
      });
      audioRefs.current[soundKey] = audio;
    } catch (error) {
      // Sound not available in this environment
    }
  }, [isMuted]);

  const stopSound = useCallback((soundKey) => {
    if (audioRefs.current[soundKey]) {
      audioRefs.current[soundKey].pause();
      audioRefs.current[soundKey].currentTime = 0;
    }
  }, []);

  const toggleMute = useCallback(() => {
    setIsMuted(prev => !prev);
  }, []);

  return {
    playSound,
    stopSound,
    toggleMute,
    isMuted
  };
};

export default useSound;
